import Font from './Font';

export default Font;
